import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@mui/material';
import { v4 } from 'uuid';
import { observer } from 'mobx-react-lite';
import AddIcon from '@mui/icons-material/Add';
import NoteCreateOrEdit from './NoteCreateOrEdit';
import CustomButton from '../../common/CustomButton';
import { useTokens } from '@mcn-platform/models';
const AddNote = ({ isCourseItemSelected, makeReference, handleAddNote }) => {
    const tokens = useTokens();
    const [isAddNew, setIsAdd] = useState(false);
    const [newNote, setNewNote] = useState('');
    const [newNoteRef, setNewNoteRef] = useState([]);
    const addNote = () => {
        if (newNote.trim().length === 0) {
            console.log('Not saving zero length note');
            return;
        }
        handleAddNote({
            id: v4(),
            reference: newNoteRef[0],
            name: newNoteRef[1],
            content: newNote,
        });
        setNewNote('');
        setIsAdd(false);
    };
    const handleCancel = () => {
        setNewNote('');
        setIsAdd(false);
    };
    return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', px: 1 }, children: isAddNew
            ? (_jsx(Box, { sx: { my: 2, width: '100%' }, children: _jsx(NoteCreateOrEdit, { value: newNote, disabled: !isCourseItemSelected, handleFocus: () => setNewNoteRef(makeReference()), handleChange: (value) => setNewNote(value), handleSave: addNote, handleCancel: handleCancel }) }))
            : (_jsx(CustomButton, { startIcon: _jsx(AddIcon, {}), areaID: "createNote", label: tokens.getToken('addNoteButtonLabel'), disabled: !isCourseItemSelected, onClick: () => setIsAdd(true), customStyle: { my: 2, width: 110 } })) }));
};
export default observer(AddNote);
//# sourceMappingURL=AddNote.js.map